/* ========================================================================= */
/* User Agent */
/* ========================================================================= */

let USER_AGENT = {};

/**
 * Set global variable USER_AGENT
 * @param {string} ua Browser's user agent
 */
export const setUserAgent = (ua) => {
    USER_AGENT = ua;
};

/**
 * Get global variable USER_AGENT
 * @return {string}
 */
export default () => {
    return USER_AGENT;
};
